import styled from '@emotion/styled';
import { useAtom } from'jotai';
import { useRef, useEffect } from 'react';
import { selectedImagesAtom ,sendingPhotoArrAtom } from '../onboardingAtom';
import ReactGA from "react-ga4";

interface PhotoContainerProps {
}

const PhotoContainer:React.FC<PhotoContainerProps> = () => {
  const [selectedImage, setSelectedImage] = useAtom(selectedImagesAtom);
  const [sendingPhoto, setSendingPhoto] = useAtom(sendingPhotoArrAtom);
  const fileInputRef = useRef(null);
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const handlePhotoButtonClick = async () => {
    //@ts-ignore
    await fileInputRef.current.click();
  };

  const handleFileSelect = (e: any) => {
    const files = e.target.files;
    if (gaId) {
      ReactGA.event({
        "category": "Button",
        "action" : "Click",
        "label" : "upload Photo FreeKit"
      })
    }

    let modifiedFiles:any;
    let selectedFilesArr:any = [];
    if (files.length < 5) {
      selectedFilesArr = []
      setSelectedImage(selectedFilesArr);
    } 
    else if (files.length >= 5) {
      modifiedFiles = Array.from(files).slice(0,5);
      for (let i=0; i < modifiedFiles.length; i++) {
        const file = files[i];
        selectedFilesArr.push(URL.createObjectURL(file));
      }
      setSelectedImage(selectedFilesArr);
      setSendingPhoto(modifiedFiles)
    }
  };  

  useEffect(() => {
    setSelectedImage(selectedImage)
  }, [])
  
  return (
    <>
    {selectedImage.length > 0 ? (
      <Container>
        <UnselectdPhotoWrapper>
          <SquareWrapper className="button">
          <PhotoSelectButton
            onClick={handlePhotoButtonClick}
            >
            <ButtonTextContainer>
              <div className="plus">+</div>
              <div className="context">사진 변경</div>
            </ButtonTextContainer>
          </PhotoSelectButton>
            <input 
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              multiple
              onChange={handleFileSelect}
              name="filename"
              max="5"
            />
          </SquareWrapper>
          <SquareWrapper
          >
            {selectedImage.length > 0 && (
              <SelectPhotoWrapper src={selectedImage[0]} />
            )}
          </SquareWrapper>
        </UnselectdPhotoWrapper>
        <UnselectdPhotoWrapper>
        <SquareWrapper>
            {selectedImage.length > 1 && (
              <SelectPhotoWrapper src={selectedImage[1]} />
            )}
          </SquareWrapper>
          <SquareWrapper>
            {selectedImage.length > 2 && (
              <SelectPhotoWrapper src={selectedImage[2]} />
            )}
          </SquareWrapper>
        </UnselectdPhotoWrapper>
        <UnselectdPhotoWrapper>
          <SquareWrapper>
            {selectedImage.length > 3 && (
              <SelectPhotoWrapper src={selectedImage[3]} />
            )}
          </SquareWrapper>
          <SquareWrapper>
            {selectedImage.length > 4 && (
              <SelectPhotoWrapper src={selectedImage[4]} />
            )}
          </SquareWrapper>
        </UnselectdPhotoWrapper>
      </Container>
      ):(
        <Container>
          <UnselectdPhotoWrapper>
            <SquareWrapper className="button">
              <PhotoSelectButton
                onClick={handlePhotoButtonClick}
                >
              <ButtonTextContainer>
                <div className="plus">+</div>
                <div className="context">사진 추가</div>
              </ButtonTextContainer>
            </PhotoSelectButton>
              <input 
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                multiple
                max="5"
                onChange={handleFileSelect}
              />
            </SquareWrapper>
            <SquareWrapper />
          </UnselectdPhotoWrapper>
          <UnselectdPhotoWrapper>
            <SquareWrapper />
            <SquareWrapper />
          </UnselectdPhotoWrapper>
          <UnselectdPhotoWrapper>
          <SquareWrapper />
            <SquareWrapper />
          </UnselectdPhotoWrapper>
        </Container>
      )}
    </>
  );
};

export default PhotoContainer;

const Container = styled.div`
  width: 304px;
  /* height: 200px; */
  height: 100%;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  justify-content: space-between;
`
const SelectPhotoWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit:cover;
`
const UnselectdPhotoWrapper = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const SquareWrapper = styled.div`
  /* width: 98px; */
  width: 48%;
  /* aspect-ratio: 1/1; */
  /* height: 94px; */
  height: 93%;
  border: 0.8px solid #262626;
`
const PhotoSelectButton = styled.button`
  width: 100%;
  height: 100%;
  color: black;
  background-color: white;
`
const ButtonTextContainer = styled.div`
  div {
    &.plus{
      color: rgba(155, 155, 155, 1);
      font-size: 30px;
      margin-bottom: 1.5px;
    }
  }
`